/* Ninho Casa — neve a cair (leve, sem dependências).
   - Não corre com "reduzir movimento" ligado.
   - Pára quando o separador está escondido (poupa bateria).
   - Não bloqueia cliques (pointer-events: none no CSS). */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var canvas = document.createElement('canvas');
  canvas.className = 'natal-neve';
  canvas.setAttribute('aria-hidden', 'true');
  document.body.appendChild(canvas);

  var ctx = canvas.getContext('2d');
  if (!ctx) return;

  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var flocos = [];
  var largura = 0;
  var altura = 0;
  var animacao = null;

  function quantidade() {
    // Menos flocos em ecrãs pequenos.
    return Math.round(Math.min(120, Math.max(35, (largura * altura) / 14000)));
  }

  function novoFloco(noTopo) {
    return {
      x: Math.random() * largura,
      y: noTopo ? -10 : Math.random() * altura,
      r: 1 + Math.random() * 2.6,
      vy: 0.4 + Math.random() * 1.1,
      vx: -0.3 + Math.random() * 0.6,
      fase: Math.random() * Math.PI * 2,
      alfa: 0.55 + Math.random() * 0.4
    };
  }

  function redimensionar() {
    largura = window.innerWidth;
    altura = window.innerHeight;
    canvas.width = largura * dpr;
    canvas.height = altura * dpr;
    canvas.style.width = largura + 'px';
    canvas.style.height = altura + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var alvo = quantidade();
    while (flocos.length < alvo) flocos.push(novoFloco(false));
    flocos.length = alvo;
  }

  function desenhar() {
    ctx.clearRect(0, 0, largura, altura);
    for (var i = 0; i < flocos.length; i++) {
      var f = flocos[i];
      f.fase += 0.01;
      f.y += f.vy;
      f.x += f.vx + Math.sin(f.fase) * 0.3;
      if (f.y > altura + 10 || f.x < -10 || f.x > largura + 10) flocos[i] = novoFloco(true);
      ctx.beginPath();
      ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,255,255,' + f.alfa + ')';
      ctx.shadowColor = 'rgba(120,140,160,0.35)';
      ctx.shadowBlur = 2;
      ctx.fill();
    }
    animacao = window.requestAnimationFrame(desenhar);
  }

  function iniciar() { if (!animacao) animacao = window.requestAnimationFrame(desenhar); }
  function parar() { if (animacao) { window.cancelAnimationFrame(animacao); animacao = null; } }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) parar(); else iniciar();
  });
  window.addEventListener('resize', redimensionar, { passive: true });

  redimensionar();
  iniciar();
})();
